import { IPortabilityMobileCMS } from '@vfit/consumer/data-access';

export const organizePortabilityCard = (portabilityCardCms: IPortabilityMobileCMS) => ({
  errorOnPortability: {
    errorMessage: {
      genericError: {
        title: portabilityCardCms?.portabilitymobile?.errorOnPortability?.message || '',
        buttonLabel: portabilityCardCms?.portabilitymobile?.errorOnPortability?.buttonLabel || '',
      },
    },
  },
  title: portabilityCardCms?.portabilitymobile?.general?.title || '',
  description: portabilityCardCms?.portabilitymobile?.general?.description || '',
  bottomText: portabilityCardCms?.portabilitymobile?.general?.bottomText || '',
  items: [
    {
      title:
        portabilityCardCms?.portabilitymobile?.general?.choicePortability?.option1?.title || '',
      value: 'yes',
    },
    {
      title:
        portabilityCardCms?.portabilitymobile?.general?.choicePortability?.option2?.title || '',
      value: 'no',
    },
  ],
});
